import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import api from '../utils/api';
import './AuthPages.css';

export default function RegisterPage() {
  const [form, setForm] = useState({ first_name: '', last_name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { toast } = useToast();
  const nav = useNavigate();

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    if (form.password.length < 8) { toast('Password must be at least 8 characters', 'error'); return; }
    setLoading(true);
    try {
      const { data } = await api.post('/auth/register', form);
      login(data.token, data.user);
      nav('/dashboard', { replace: true });
      toast(`Welcome, ${data.user.first_name}! 🎉`, 'success');
    } catch (err) {
      toast(err.response?.data?.error || 'Registration failed', 'error');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-card card">
        <div className="auth-header">
          <Link to="/" className="auth-logo">PropertyTraining<span>.ai</span></Link>
          <h1>Create your account</h1>
          <p>Start learning with Amanda AI today</p>
        </div>
        <form onSubmit={submit}>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px'}}>
            <div className="form-group">
              <label className="form-label">First name</label>
              <input name="first_name" className="form-input" placeholder="Amanda" value={form.first_name} onChange={handle} required />
            </div>
            <div className="form-group">
              <label className="form-label">Last name</label>
              <input name="last_name" className="form-input" placeholder="Smith" value={form.last_name} onChange={handle} />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Email address</label>
            <input name="email" type="email" className="form-input" placeholder="you@example.com" value={form.email} onChange={handle} required />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input name="password" type="password" className="form-input" placeholder="At least 8 characters" value={form.password} onChange={handle} required />
          </div>
          <button type="submit" className={`btn btn-primary btn-full mt-2 ${loading ? 'btn-loading' : ''}`} disabled={loading}>
            {loading ? '' : 'Create account →'}
          </button>
        </form>
        <p className="auth-legal">By creating an account you agree to our <Link to="/terms">Terms of Service</Link> and <Link to="/privacy">Privacy Policy</Link>.</p>
        <div className="auth-footer">
          <p>Already have an account? <Link to="/login">Sign in</Link></p>
        </div>
      </div>
    </div>
  );
}
